import { Record } from 'immutable'

export class DietRate extends Record({
    id: undefined,
    country_id: undefined,
    currency_id: undefined,
    rate: undefined,
}) {}
